export enum HouseBetas {
    LiveShippingViaPackengers = 36,
    LiveShippingViaNationalLogisticsService = 37,
    LiveShippingViaShippingSaint = 49,
    ATGPay = 41,
    InvisibleApproval = 48,
}
